/**
 * Capitalizes the first letter of admin-entered text so it reads as a
 * sentence in-game, without touching the rest of the string — a full
 * lowercase-everything transform would mangle intentional capitalization
 * (proper nouns, acronyms) that lives inside free-text admin fields.
 */
export const toSentenceCase = (text) => {
  if (typeof text !== 'string') return text;
  const trimmed = text.trimStart();
  const leadingWhitespace = text.slice(0, text.length - trimmed.length);
  if (!trimmed) return text;
  return leadingWhitespace + trimmed.charAt(0).toUpperCase() + trimmed.slice(1);
};
